<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='650px' center
             v-loading='dialogLoading' @close='dialogClose'>
    <div class='p20'>
      <div-border label='基础信息' style='padding:20px 20px 10px'>
        <el-form :model='form' label-width='130px' :rules='rules' ref='ruleForm'>
          <el-row>
            <el-col :span='24'>
              <el-form-item label='登录账号：' prop='account' v-if="dialogTitle!=='修改用户'">
                <el-input style='width:100%' v-model='form.account' placeholder='请输入登录账号'
                          autocomplete='off' size='small' />
              </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-form-item label='登录密码：' prop='password' v-if="dialogTitle!=='修改用户'">
                <el-input style='width:100%' v-model='form.password' placeholder='请输入登录密码'
                          autocomplete='off' size='small' show-password />
              </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-form-item label='所属部门：' prop='depId'>
                <el-select v-model='form.depId' size='small' filterable
                           style='width:100%' placeholder='请选择所属部门'>
                  <el-option v-for='item in departmentOption' :key='item.id' :label='item.depNm'
                             :value='item.id' />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='PC所属角色：' prop='roleId'>
                <el-select v-model='form.roleId' size='small' filterable style='width:100%'
                           placeholder='请选择所属角色'>
                  <el-option v-for='item in roleOption' :key='item.id' :label='item.roleNm'
                             :value='item.id' />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='APP所属角色：' prop='appRoleId'>
                <el-select v-model='form.appRoleId' size='small' filterable style='width:100%'
                           placeholder='请选择所属角色'>
                  <el-option v-for='item in appRoleOption' :key='item.id' :label='item.roleName'
                             :value='item.id' />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-form-item label='服务港口：'>
                <el-select v-model='form.employeePorts' size='small' filterable multiple
                           placeholder='请选择服务港口' style='width:100%'>
                  <el-option v-for='item in employeePortsOptions' :key='item.id' :label='item.name'
                             :value='item.id'>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-form-item label='员工姓名：' prop='empNm'>
                <el-input style='width:100%' v-model='form.empNm' placeholder='请输入用户姓名'
                          autocomplete='off' size='small' />
              </el-form-item>

            </el-col>
            <el-col :span='24'>
              <el-form-item label='邮箱：' prop='email'>
                <el-input style='width:100%' v-model='form.email' placeholder='请输入用户邮箱'
                          autocomplete='off' size='small' />
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='性别：'>
                <el-radio-group v-model='form.empGender'>
                  <el-radio label='1'>男</el-radio>
                  <el-radio label='2'>女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='年龄：'>
                <el-input style='width:100%' v-model='form.age' placeholder='请输入用户年龄'
                          autocomplete='off' size='small' />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div-border>
      <div class='btnContainer'>
        <el-button size='medium' class='searchBtn' :loading='buttonLoading' @click='submit'>
          {{ dialogTitle === '新增用户' ? '新增' : '修改' }}
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { shipDeployPublicSelectPort } from '@/service/vehiclelog';
  import {
    addEmployee,
    editEmployee, qryEmployeeDetail,
    selectAppRoleAll,
    selectDepartmentAll,
    selectRoleAll,
  } from '@/service/basicfile';
  import { removeSpace } from '@/config/mUtils';
  import DivBorder from '@/components/divBorder';

  export default {
    name: 'user-new',
    components: { DivBorder },
    data() {
      return {
        dialogTitle: '',
        dialogVisible: false,
        dialogLoading: false,
        buttonLoading: false,
        defaultForm: {},
        form: {
          password: '888888',
        },
        rules: {
          orgId: [
            {
              required: true,
              message: '请选择用户所在公司',
              trigger: 'change',
            },
          ],
          empNm: [
            {
              required: true,
              message: '请输入用户姓名',
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              message: '请输入登录密码',
              trigger: 'blur',
            },
          ],
          account: [
            {
              required: true,
              message: '请输入登录账号',
              trigger: 'blur',
            },
          ],
          email: [
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur'],
            },
          ],
          employeePorts: [
            {
              required: true,
              message: '请输入服务港口',
              trigger: 'blur',
            },
          ],
          empGender: [
            {
              required: true,
              message: '请选择用户性别',
              trigger: 'change',
            },
          ],
          age: [
            {
              required: true,
              message: '请输入用户年龄',
              trigger: 'blur',
            },
          ],
          roleId: [
            {
              required: true,
              message: '请选择PC所属角色',
              trigger: 'change',
            },
          ],
          appRoleId: [
            {
              required: true,
              message: '请选择APP所属角色',
              trigger: 'change',
            },
          ],
          depId: [
            {
              required: true,
              message: '请选择所属部门',
              trigger: 'change',
            },
          ],
        },
        departmentOption: [],
        roleOption: [],
        appRoleOption: [],
        employeePortsOptions: [],
      };
    },
    created() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
      this.shipDeployPublicSelectPort();
      this.selectDepartmentAll();
      this.selectRoleAll();
      this.selectAppRoleAll();
    },
    methods: {
      dialogOpen(title, id) {
        this.dialogTitle = title;
        if (id) this.getDefaultDate(id);
        this.dialogVisible = true;
        console.log(this.departmentOption, this.roleOption, this.appRoleOption, this.employeePortsOptions);
      },
      async getDefaultDate(id) {
        const res = await qryEmployeeDetail(id);
        if (res.status !== 0) return this.$message.warning(res.message);
        const employeePorts = [];
        if (res.data.employeePorts) {
          for (const item of res.data.employeePorts) {
            employeePorts.push(item.portId);
          }
        }
        this.form = {
          ...res.data,
          employeePorts,
        };
      },
      // 获取港口
      async shipDeployPublicSelectPort() {
        let res = await shipDeployPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.employeePortsOptions = res.data.map(item => {
          return {
            name: item.supplier_name,
            id: item.id,
          };
        });
      },
      // 获取部门
      async selectDepartmentAll() {
        let res = await selectDepartmentAll();
        if (res.status !== 0) return this.$message.error(res.message);
        this.departmentOption = res.data;
      },
      // 获取PC角色
      async selectRoleAll() {
        let res = await selectRoleAll();
        if (res.status !== 0) return this.$message.error(res.message);
        this.roleOption = res.data;
      },
      // 获取APP角色
      async selectAppRoleAll() {
        let res = await selectAppRoleAll();
        if (res.status !== 0) return this.$message.error(res.message);
        this.appRoleOption = res.data;
      },
      dialogClose() {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.dialogVisible = false;
      },
      submit() {
        const employeePorts = [];
        for (const item of this.employeePortsOptions) {
          if (this.form.employeePorts) {
            for (const value of this.form.employeePorts) {
              if (item.id === value) {
                const port = {
                  portId: value,
                  portName: item.name,
                };
                employeePorts.push(port);
              }
            }
          }
        }
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.buttonLoading = true;
            const res = this.dialogTitle === '新增用户' ? await addEmployee({
              ...this.form,
              employeePorts,
            }) : await editEmployee({
              ...this.form,
              employeePorts,
            });
            this.buttonLoading = false;
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            this.dialogClose();
            this.$emit('success');
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
